import React from "react";
import { useWhiteboardRoom } from "../../hooks/useWhiteboardRoom";
import { getProticoClient } from "../../utils/api";

interface IblockListContext {
  blockList: Array<string>;
  domainAllowList: Array<string>;
  isAllowGuest: boolean;
  isLoading: boolean;
}

export const blockListContext = React.createContext<IblockListContext>({
  blockList: [],
  domainAllowList: [],
  isAllowGuest: true,
  isLoading: true,
});

export const BlockListProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [blockList, setBlockList] = React.useState([]);
  const [domainAllowList, setDomainAllowList] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(true);
  const [isAllowGuest, setIsAllowGuest] = React.useState(true);
  const { roomDomain } = useWhiteboardRoom();
  React.useEffect(() => {
    const init = async () => {
      const blocklist = await getProticoClient().blocklist.get(roomDomain);
      setBlockList(blocklist.map((item) => item.address));
      const domainSettingRes =
        await getProticoClient().settings.getDomainSettings(roomDomain);
      setIsAllowGuest(domainSettingRes.allow_guest_user);
      setDomainAllowList(domainSettingRes.domain_allowlist);
      setIsLoading(false);
    };
    if (roomDomain) {
      init();
    }
  }, [roomDomain]);

  return (
    <blockListContext.Provider value={{ blockList, isLoading, isAllowGuest, domainAllowList }}>
      {children}
    </blockListContext.Provider>
  );
};
